import React from "react";
import styled from "styled-components";
import { envStaticHost, getPartnerConfiguration } from "../Utils/windowHelper";
import { translate, translateDate } from "../Utils/language";

type Props = {
  category: string;
  starttime: Date;
  endtime: Date;
  referer: string;
  language: string;
};

const NoEnabledProducts: React.FC<Props> = ({ category, starttime, endtime, referer, language }) => {
  /**
   * It takes a date as an argument and returns a string in the format of "day day.month"
   * @param {Date} date - The date to format
   * @returns a formatted time string according to the current language
   */

  const configuration = getPartnerConfiguration(referer);

  const mapTailoredConfig = configuration && configuration.SHOW_COMPONENT_BASED_ON_CATEGORY.includes(category);

  const handleClick = () => {
    const body = document.querySelector("#available");

    body?.scrollIntoView({
      behavior: "smooth",
    });
  };

  const noProductsOnTimelinePageV1 = configuration && configuration.NO_PRODUCTS_ON_TIMELINE_PAGE === "1";

  return (
    <Wrapper>
      {noProductsOnTimelinePageV1 ? (
        <>
          <IconWrapper style={{ alignItems: "flex-start" }}>
            {" "}
            <TextWrapper>
              {" "}
              <RoundedIcon />{" "}
              <p>
                {translate(language, "Start")} <span>{translateDate(language, starttime, "wmd")}</span>{" "}
              </p>
            </TextWrapper>
            <Line>
              <div></div>
            </Line>
            <div>
              {" "}
              <RoundedIcon />{" "}
              <p>
                {translate(language, "End")} <span>{translateDate(language, endtime, "wmd")}</span>{" "}
              </p>
            </div>
          </IconWrapper>

          <Border>
            <div>
              <img
                src={
                  mapTailoredConfig
                    ? `${envStaticHost}/static/${referer}/error/Empty1.png`
                    : `${envStaticHost}/static/${referer}/error/Empty2.png`
                }
                alt="no enabled item"
                onClick={handleClick}
              />
            </div>

            <div>
              <h5>
                {mapTailoredConfig
                  ? translate(language, "Create your individual trip")
                  : translate(language, "Add products and options")}
              </h5>
            </div>
          </Border>
        </>
      ) : (
        <>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
            <img
              src={
                mapTailoredConfig
                  ? `${envStaticHost}/static/${referer}/error/Empty1.png`
                  : `${envStaticHost}/static/${referer}/error/Empty2.png`
              }
              alt="no enabled item"
              style={{ width: "70px", height: "auto", marginBottom: "10px" }}
            />
            <h5 style={{ width: "50%" }}>
              {mapTailoredConfig
                ? translate(language, "Create your individual trip")
                : translate(language, "Add products and options")}
            </h5>
          </div>
        </>
      )}
    </Wrapper>
  );
};

const RoundedIcon = styled.div`
  border: 3px solid var(--clr-primary-1);
  height: 20px;
  width: 20px;
  border-radius: var(--radius-50);
  background: var(--clr-white);
  margin-right: 10px;
`;

const Wrapper = styled.div`
  padding: 5px 15px;
  position: relative;
`;

const Line = styled.div`
  height: 18rem;
  margin: 0 auto;
  padding: 0 8.5px;

  div {
    width: 2px;
    background-color: var(--vertical-div);
  }
`;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.div`
  margin: 0 50.5px 1rem;
  @media screen and (min-width: 800px) {
    margin: 0 57px 1rem;
  }

  div {
    display: flex;
  }

  p {
    color: var(--clr-NoEnabledProducts-text);

    span {
      font-family: var(--p-bold);
    }
  }
`;

const Border = styled.div`
  border: 2px dashed var(--dotted-dash);
  height: 15rem;
  border-radius: var(--radius-components);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3rem auto;
  background: var(--popup-bg);
  position: absolute;
  top: 0;
  width: 90%;

  h5 {
    text-align: left;
    color: var(--clr-NoEnabledProducts-text);
  }

  div:first-child {
    width: 35%;
    text-align: center;

    img {
      width: 65%;
    }
  }

  div:last-child {
    padding: 0 15px;
    width: 60%;

    p {
      text-align: center;
    }
  }

  @media screen and (min-width: 800px) {
    flex-direction: column;
    height: 15rem;
    justify-content: space-evenly;

    div:first-child {
      width: 100%;

      img {
        height: 100%;
        width: 7rem;
      }
    }

    div:last-child {
      width: 100%;
    }
  }
`;

export default NoEnabledProducts;
